module.exports = __webpack_public_path__ + "static/media/expert-advice.baf109c8.png";